import Model from './Model'

export default class Email extends Model {
  resource () {
    return 'emails'
  }

  bulk (data: Object) {
    return this.action('bulk', data)
  }
}
